import { useConfigQuery } from './useConfigQuery'

export const useStoreHash = (): string => {
  const config = useConfigQuery();
  return config?.data?.storeHash;
}
